import { h, Component } from "preact";
import { useEffect, useState } from "preact/hooks";
import { useDispatch, useSelector } from "react-redux";

import questionnaire from "../api/questionnaire.js";
import { sendError } from "../errors.js";
import { setLoading } from "../store";

import bankAccount from "./pages/bank_account.jsx";
import bankOpenAccount from "./pages/bank_open_account.jsx";
import diplomaticMission from "./pages/diplomatic_mission.jsx";
import healthInsurance from "./pages/health_insurance.jsx";
import immigrationOffice from "./pages/immigration_office.jsx";
import jobSearch from "./pages/job_search.jsx";
import qualificationsRecognition from "./pages/qualifications_recognition.jsx";
import preAssessment from "./pages/pre_assessment.jsx";
import registration from "./pages/registration.jsx";
import registrationAuthority from "./pages/registration_authority.jsx";
import regulatedProfessionCheck from "./pages/regulated_profession_check.jsx";
import legalRequirementCheck from "./pages/legal_requirement_check.jsx";
import residencyPermitApplication from "./pages/residency_permit_application.jsx";
import residencyPermitCheck from "./pages/residency_permit_check.jsx";
import statementOfComparability from "./pages/statement_of_comparability.jsx";
import visaApplication from "./pages/visa_application.jsx";
import visaCheck from "./pages/visa_check.jsx";

const PAGES = {
  ...bankAccount,
  ...bankOpenAccount,
  ...diplomaticMission,
  ...healthInsurance,
  ...immigrationOffice,
  ...jobSearch,
  ...qualificationsRecognition,
  ...preAssessment,
  ...registration,
  ...registrationAuthority,
  ...regulatedProfessionCheck,
  ...legalRequirementCheck,
  ...residencyPermitApplication,
  ...residencyPermitCheck,
  ...statementOfComparability,
  ...visaApplication,
  ...visaCheck,
  TODO: () => {
    return (
      <section>
        <h1 class="t-h6">TODO</h1>
      </section>
    );
  },
};

export default function Page(props) {
  const PageComponent = PAGES[props.pageId];
  const [_error, setError] = useState(null);
  const [answers, setAnswers] = useState(null);
  const loading = useSelector((state) => state.ui.loading);
  const dispatch = useDispatch();

  if (!PageComponent) {
    throw new Error(`Page ${props.pageId} not defined. Please define it.`);
  }

  async function loadAnswers() {
    dispatch(setLoading(true));
    try {
      setError(null);
      setAnswers(await questionnaire.fetchAnswers());
    } catch (err) {
      sendError(err);
      // TODO: some handing is needed here
      setError(err);
    }
    dispatch(setLoading(false));
  }

  useEffect(async () => {
    if (!props.noAnswersNeeded) {
      await loadAnswers();
    } else {
      dispatch(setLoading(false));
    }
  }, []);

  // TODO: show error

  if (!answers) {
    return null;
  }

  return <PageComponent {...props} answers={answers} />;
}
